import { render, staticRenderFns } from "./TrainForm.vue?vue&type=template&id=a8fe3460"
import script from "./TrainForm.vue?vue&type=script&lang=ts"
export * from "./TrainForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports